import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const radioButtonStyles = tv({
    slots: {
        base: `
      iris:flex
      iris:size-(--comp-size-box-check-radio-control)
      iris:flex-shrink-0
      iris:cursor-pointer
      iris:items-center
      iris:justify-center
      iris:rounded-(--comp-size-radius-radio-control)
      iris:border-(length:--comp-size-border-check-radio-control)
      iris:transition-all
      iris:duration-(--comp-motion-duration-check-radio)
      iris:ease-(--comp-motion-easing-check-radio)
    `,
        indicator: `
      iris:h-[50%]
      iris:w-[50%]
      iris:rounded-(--comp-size-radius-radio-control)
      iris:bg-(--comp-color-background-check-radio-control-selected)
    `,
    },
    variants: {
        inverse: {
            false: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-rest)
          iris:bg-(--comp-color-background-check-radio-control-rest)
          iris:group-data-[state=checked]:border-(--comp-color-border-check-radio-control-selected)
          iris:group-data-[state=checked]:bg-(--comp-color-background-check-radio-control-rest)
          iris:data-[state=checked]:border-(--comp-color-border-check-radio-control-selected)
          iris:data-[state=checked]:bg-(--comp-color-background-check-radio-control-rest)
          ${focusStyles.default}
        `,
                indicator: `iris:bg-(--comp-color-background-check-radio-control-selected)`,
            },
            true: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-inverse-rest)
          iris:bg-(--comp-color-background-check-radio-control-inverse-rest)
          iris:group-data-[state=checked]:border-(--comp-color-border-check-radio-control-inverse-selected)
          iris:group-data-[state=checked]:bg-(--comp-color-background-check-radio-control-inverse-rest)
          iris:data-[state=checked]:border-(--comp-color-border-check-radio-control-inverse-selected)
          iris:data-[state=checked]:bg-(--comp-color-background-check-radio-control-inverse-rest)
          ${focusStyles.inverse}
        `,
                indicator: "iris:bg-(--comp-color-background-check-radio-control-inverse-selected)",
            },
        },
        error: {
            true: "",
            false: "",
        },
        disabled: {
            true: {
                base: `
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
            },
            false: {},
        },
    },
    compoundVariants: [
        {
            inverse: false,
            disabled: false,
            class: {
                base: `
        iris:group-hover:border-(--comp-color-border-check-radio-control-hover)
        iris:group-hover:bg-(--comp-color-background-check-radio-control-hover)
        iris:hover:border-(--comp-color-border-check-radio-control-hover)
        iris:hover:bg-(--comp-color-background-check-radio-control-hover)
        `,
            },
        },
        {
            inverse: true,
            disabled: false,
            class: {
                base: `
          iris:group-hover:border-(--comp-color-border-check-radio-control-inverse-hover)
          iris:group-hover:bg-(--comp-color-background-check-radio-control-inverse-hover)
          iris:hover:border-(--comp-color-border-check-radio-control-inverse-hover)
          iris:hover:bg-(--comp-color-background-check-radio-control-inverse-hover)
        `,
            },
        },
        {
            disabled: true,
            inverse: false,
            class: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-rest)
          iris:bg-(--comp-color-background-check-radio-control-rest)
        `,
            },
        },
        {
            disabled: true,
            inverse: true,
            class: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-inverse-rest)
          iris:bg-(--comp-color-background-check-radio-control-inverse-rest)
        `,
            },
        },
        {
            inverse: false,
            error: true,
            class: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-error)
          iris:bg-(--comp-color-background-check-radio-control-rest)
        `,
            },
        },
        {
            inverse: true,
            error: true,
            class: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-inverse-error)
          iris:bg-(--comp-color-background-check-radio-control-inverse-error)
        `,
            },
        },
    ],
});

export { radioButtonStyles as default };
